export default {"src":"/_next/static/media/goat.c9dc63cb.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};